/**
 * internal dependencies
 */
import { IPinPoolIndivdiual } from "../../../../../models/cardgroup.interface";
import { COMMON_FORM_ELEMENTS, PIN_POOL_ACTIONS } from '../utils/pin-pool-types';
import PostPinPool from '../../../../../routes/post-pin-pool';
import { showToast } from '../../../../toasts';

/**
 * Function handles removing the pin from the pin pool 
 * 
 * @param currentPin Individual Pin
 */
export const removePin = async (currentPin: IPinPoolIndivdiual, askFor: number) => {

  const awsData = {
    cardGroupId: +COMMON_FORM_ELEMENTS.ceCardGroupName.dataset.cardGroupId!,
    askFor,
    pin: currentPin.validValue,
    action: PIN_POOL_ACTIONS.REMOVEINDIVIDUALPIN
  };

  try {
    const { statusCode } = await PostPinPool(awsData);
    if (statusCode === 200) {
      showToast('aafp_toast', `Pin has been removed`);
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  } catch (error) {
    console.error('Error removing pin', error);
  }
};